export const SETTINGS_PAGE_SET_SECTION = 'SETTINGS_PAGE_SET_SECTION'
export const SETTINGS_PAGE_SET_DEFAULT_SHIP_TO =
  'SETTINGS_PAGE_SET_DEFAULT_SHIP_TO'
export const CHECKIN_LOCATIONS_REQUEST_PENDING =
  'CHECKIN_LOCATIONS_REQUEST_PENDING'
export const CHECKIN_LOCATIONS_REQUEST_SUCCESS =
  'CHECKIN_LOCATIONS_REQUEST_SUCCESS'
export const CHECKIN_LOCATIONS_REQUEST_FAILURE =
  'CHECKIN_LOCATIONS_REQUEST_FAILURE'
